import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { createLayerContainer } from '@antv/l7-core';
import { DOM } from '@antv/l7-utils';
export function registerLayers(parentLayer, layers) {
  layers.map(function (layer) {
    var container = createLayerContainer(parentLayer.sceneContainer);
    layer.setContainer(container, parentLayer.sceneContainer);
    layer.init();
  });
}
export function getLayerShape(layerType, layer) {
  var _layerShape$scale;

  var layerShape = layer.getAttribute('shape');

  if (layerShape && (_layerShape$scale = layerShape.scale) !== null && _layerShape$scale !== void 0 && _layerShape$scale.field) {
    var _layerShape$scale2;

    if (((_layerShape$scale2 = layerShape.scale) === null || _layerShape$scale2 === void 0 ? void 0 : _layerShape$scale2.values) === 'text') {
      return [layerShape.scale.field, layerShape.scale.values];
    }

    return layerShape.scale.field;
  }

  switch (layerType) {
    case 'PolygonLayer':
      return 'fill';

    case 'LineLayer':
      return 'tileline';

    case 'PointLayer':
      return 'circle';

    case 'RasterLayer':
      return 'image';

    default:
      return '';
  }
}
export function getMaskValue(layerType, mask) {
  switch (layerType) {
    case 'PolygonLayer':
      return true;

    case 'LineLayer':
      return true;

    case 'PointLayer':
      return false;

    case 'RasterLayer':
      return mask;

    default:
      return mask;
  }
}
export function getContainerSize(container) {
  if (!!container.getContext) {
    return {
      width: container.width / DOM.DPR,
      height: container.height / DOM.DPR
    };
  } else {
    return container.getBoundingClientRect();
  }
}
export function readRasterValue(tile, mapService, x, y) {
  var _tile$bboxPolygon, _tile$data, _tile$data2, _tile$data3;

  var bbox = (tile === null || tile === void 0 ? void 0 : (_tile$bboxPolygon = tile.bboxPolygon) === null || _tile$bboxPolygon === void 0 ? void 0 : _tile$bboxPolygon.bbox) || [0, 0, 10, -10];

  var _bbox = _slicedToArray(bbox, 4),
      _bbox$ = _bbox[0],
      minLng = _bbox$ === void 0 ? 0 : _bbox$,
      _bbox$2 = _bbox[1],
      minLat = _bbox$2 === void 0 ? 0 : _bbox$2,
      _bbox$3 = _bbox[2],
      maxLng = _bbox$3 === void 0 ? 10 : _bbox$3,
      _bbox$4 = _bbox[3],
      maxLat = _bbox$4 === void 0 ? -10 : _bbox$4;

  var tileXY = mapService.lngLatToContainer([minLng, minLat]);
  var tileMaxXY = mapService.lngLatToContainer([maxLng, maxLat]);
  var tilePixelWidth = tileMaxXY.x - tileXY.x;
  var tilePixelHeight = tileXY.y - tileMaxXY.y;
  var pos = [(x - tileXY.x) / tilePixelWidth, (y - tileMaxXY.y) / tilePixelHeight];
  var tileWidth = (tile === null || tile === void 0 ? void 0 : (_tile$data = tile.data) === null || _tile$data === void 0 ? void 0 : _tile$data.width) || 1;
  var tileHeight = (tile === null || tile === void 0 ? void 0 : (_tile$data2 = tile.data) === null || _tile$data2 === void 0 ? void 0 : _tile$data2.height) || 1;
  var indexX = Math.floor(pos[0] * tileWidth);
  var indexY = Math.floor(pos[1] * tileHeight);
  var index = Math.max(0, indexY - 1) * tileWidth + indexX;
  var data = tile === null || tile === void 0 ? void 0 : (_tile$data3 = tile.data) === null || _tile$data3 === void 0 ? void 0 : _tile$data3.data[index];
  return data;
}
export function readPixel(x, y, rendererService) {
  var readPixels = rendererService.readPixels,
      getContainer = rendererService.getContainer;
  var xInDevicePixel = x * DOM.DPR;
  var yInDevicePixel = y * DOM.DPR;

  var _getContainerSize = getContainerSize(getContainer()),
      width = _getContainerSize.width,
      height = _getContainerSize.height;

  width *= DOM.DPR;
  height *= DOM.DPR;

  if (xInDevicePixel > width - 1 * DOM.DPR || xInDevicePixel < 0 || yInDevicePixel > height - 1 * DOM.DPR || yInDevicePixel < 0) {
    return false;
  }

  var pickedColors = readPixels({
    x: Math.floor(xInDevicePixel),
    y: Math.floor(height - (y + 1) * DOM.DPR),
    width: 1,
    height: 1,
    data: new Uint8Array(1 * 1 * 4)
  });
  return pickedColors;
}
//# sourceMappingURL=utils.js.map